import React from 'react';

import WizardForm from '../wizardform/WizardForm';
import LocationInfoForm from './locationinfoform/LocationInfoForm';
import LocationPreview from './locationpreview/LocationPreview';

export const AddLocationForm = props => {
  return (
    <WizardForm
      onSubmit={props.onSubmit}
      steps={[LocationInfoForm, LocationPreview]}
      props={{
        sites: props.sites,
        areas: props.areas,
        zones: props.zones,
        onSiteSelect: props.onSiteSelect,
        onAreaSelect: props.onAreaSelect,
        initialValues: props.initialValues,
        isEditing: props.isEditing
      }}
    />
  );
};

export default AddLocationForm;



// WEBPACK FOOTER //
// ./src/components/forms/addlocationform/AddLocationForm.js